import React from "react";
import InfoIcon from "../../images/infoIcon.svg";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorScrollbarStatus = () => {
  const {
    selectedComponent,
    editComponent,
    tempLayerScrollbarItems,
    editComponentRef,
    setEditComponent,
    setIsEditorOnScrollbarItems,
    setMultiSelectedComps,
    setSelectedComponent,
  } = useEditorMainPageContext();

  const showScrollbarStatus =
    selectedComponent?.componentType == "Scrollbar" || editComponent;

  if (!showScrollbarStatus) {
    return (
      <div
        style={{
          height: "40px",
          marginBottom: "28px",
          marginTop: "-10px",
        }}
      />
    );
  }

  return (
    <div
      className="scrollbar-status"
      style={{ width: editComponent ? "360px" : "320px" }}
    >
      <img src={InfoIcon} alt="" />
      {editComponent ? (
        <>
          <div>Click 'Done' to finalize and use the scrollbar</div>
          <button
            className="scrollbar-finalise-button"
            onClick={() => {
              tempLayerScrollbarItems.current = undefined;
              editComponentRef.current = undefined;
              setEditComponent(undefined);
              setIsEditorOnScrollbarItems("true");
              setMultiSelectedComps([]);
              setSelectedComponent({});
            }}
          >
            DONE
          </button>
        </>
      ) : (
        <div>Double Click on the scrollbar to drop components</div>
      )}
    </div>
  );
};
